import { render, staticRenderFns } from "./WaitingLettersList.vue?vue&type=template&id=01a71828"
import script from "./WaitingLettersList.vue?vue&type=script&lang=js"
export * from "./WaitingLettersList.vue?vue&type=script&lang=js"
import style0 from "./WaitingLettersList.vue?vue&type=style&index=0&id=01a71828&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports